// Dynamically configure Webpack's public path at runtime to ensure all assets
// and lazy-loaded chunks resolve correctly from the root domain or CDN,
// regardless of history routing and localized subdirectories (like /ja-jp/).
if (process.env.NODE_ENV === 'production') {
    let detectedPath = '/';

    if (typeof document !== 'undefined') {
        const scripts = document.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
            const src = scripts[i].src;
            // Check if the script URL contains 'assets-site/'
            if (src && src.includes('assets-site/')) {
                // Extract the absolute base URL up to 'assets-site/' (excluding 'assets-site/')
                const match = src.match(/^(.*\/)assets-site\//);
                if (match) {
                    detectedPath = match[1];
                    break;
                }
            }
        }
    }

    // Set Webpack's runtime public path
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = detectedPath;

    console.log('[Webpack Runtime] Dynamically configured public path to:', detectedPath);
}
